import React from "react";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { Layout } from "./components/Layout";
import { LoginPage } from "./pages/LoginPage";
import { RegisterPage } from "./pages/RegisterPage";
import { NewsListPage } from "./pages/NewsListPage";
import { NewsDetailPage } from "./pages/NewsDetailPage";
import { NotApprovedPage } from "./pages/NotApprovedPage";
import { AdminUsersPage } from "./pages/AdminUsersPage";
import { AdminNewsPage } from "./pages/AdminNewsPage";
import { ProtectedRoute } from "./components/ProtectedRoute";

const router = createBrowserRouter([
  {
    path: "/",
    element: (
      <Layout>
        <ProtectedRoute requireApproved>
          <NewsListPage />
        </ProtectedRoute>
      </Layout>
    ),
  },
  {
    path: "/news/:id",
    element: (
      <Layout>
        <ProtectedRoute requireApproved>
          <NewsDetailPage />
        </ProtectedRoute>
      </Layout>
    ),
  },
  {
    path: "/login",
    element: (
      <Layout>
        <LoginPage />
      </Layout>
    ),
  },
  {
    path: "/register",
    element: (
      <Layout>
        <RegisterPage />
      </Layout>
    ),
  },
  {
    path: "/not-approved",
    element: (
      <Layout>
        <NotApprovedPage />
      </Layout>
    ),
  },
  {
    path: "/admin/users",
    element: (
      <Layout>
        <ProtectedRoute requireRole={["admin"]}>
          <AdminUsersPage />
        </ProtectedRoute>
      </Layout>
    ),
  },
  {
    path: "/admin/news",
    element: (
      <Layout>
        <ProtectedRoute requireRole={["admin", "editor"]}>
          <AdminNewsPage />
        </ProtectedRoute>
      </Layout>
    ),
  },
]);

export const AppRouter: React.FC = () => <RouterProvider router={router} />;
